import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import { AuthProvider } from "@/context/AuthContext";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import LiveNotifier from "@/components/LiveNotifier";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Overseer from "@/pages/Overseer";
import Leadership from "@/pages/Leadership";
import Ministries from "@/pages/Ministries";
import Events from "@/pages/Events";
import Sermons from "@/pages/Sermons";
import WatchLive from "@/pages/WatchLive";
import Gallery from "@/pages/Gallery";
import Devotional from "@/pages/Devotional";
import Testimonies from "@/pages/Testimonies";
import Give from "@/pages/Give";
import Prayer from "@/pages/Prayer";
import NewHere from "@/pages/NewHere";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import EventDetails from "@/pages/EventDetails";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <AnnouncementBanner />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <AnalyticsTracker />
        <LiveNotifier />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/overseer" element={<Overseer />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/ministries" element={<Ministries />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:id" element={<EventDetails />} />
            <Route path="/sermons" element={<Sermons />} />
            <Route path="/watch-live" element={<WatchLive />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/devotional" element={<Devotional />} />
            <Route path="/testimonies" element={<Testimonies />} />
            <Route path="/give" element={<Give />} />
            <Route path="/prayer" element={<Prayer />} />
            <Route path="/new-here" element={<NewHere />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<PublicLayout />}>
            <Route index element={<Home />} />
          </Route>
        </Routes>
        <Toaster position="top-center" richColors closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}
